  import dayjs from 'dayjs';

  export function calculoinsoluto(financiamiento,plazo,interes,frecPago,fechaInicio){
    
    const montoSolicitado = financiamiento;
    const frecuencia = frecPago;

    const cuotas = Number(plazo) || 0;
    const principal = Number(montoSolicitado) || 0;
    const tasaAnual = Number(interes) || 0;
  
    if (!cuotas || !fechaInicio || !principal || tasaAnual === undefined) {
      return [];
    }
  
    // Calculate periodic interest rate based on frequency
    let r = 0; // periodic interest rate as decimal
    switch (frecuencia) {
      case 'Semanal':
        r = (tasaAnual / 100) / 4;
        break;
      case 'Quincenal':
        r = (tasaAnual / 100) / 2;
        break;
      case 'Mensual':
        r = (tasaAnual / 100) / 1;
        break;
      case 'Diario':
        r = (tasaAnual / 100) / cuotas;
        break;
      default:
        r = (tasaAnual / 100) / 1; // default to monthly
        break;
    }
  
    // German method: Fixed capital payment, decreasing interest
    const capitalFijo = principal / cuotas;
  
    const amortization = [];
    let saldo = principal;
    let fecha = dayjs(fechaInicio);
  
    for (let i = 0; i < cuotas; i++) {
      // Calculate next payment date
      switch (frecuencia) {
        case 'Diario':
          fecha = fecha.add(1, 'day');
          break;
        case 'Semanal':
          fecha = fecha.add(7, 'day');
          break;
        case 'Quincenal':
          fecha = fecha.add(15, 'day');
          break;
        default:
          fecha = fecha.add(1, 'month');
          break;
      }
  
      // German method: Fixed capital, interest on remaining balance
      let capital = capitalFijo;
      const interesPeriodo = saldo * r;
      let cuotaFinal = capital + interesPeriodo;
  
      // Adjust last payment to pay off remaining balance
      if (i === cuotas - 1) {
        capital = saldo;
        cuotaFinal = capital + interesPeriodo;
      }
  
      // Round to 2 decimal places
      capital = Math.round(capital * 100) / 100;
      const interesRedondeado = Math.round(interesPeriodo * 100) / 100;
      cuotaFinal = Math.round(cuotaFinal * 100) / 100;
  
      amortization.push({
        numero_cuota: i + 1,
        fecha: fecha.format('DD/MM/YYYY'),
        cuota: cuotaFinal.toFixed(2),
        interes: interesRedondeado.toFixed(2),
        capital: capital.toFixed(2),
      });
  
      // Update remaining balance
      saldo = Math.round((saldo - capital) * 100) / 100;
      if (saldo < 0) {
        saldo = 0;
      }
    }
  
  


    var vcuotas = amortization[0].cuota;
    var deuda = amortization.reduce((acc,curr) => acc + parseFloat(curr.cuota),0);
    

    return {cuotas:vcuotas,deuda:deuda.toFixed(2)};
  }

  export function calculoabsoluto(financiamiento,plazo,interes,frecPago){

    if( financiamiento === undefined || plazo === undefined || interes === undefined || frecPago === undefined) {
        return {cuotas:0.00,deuda:0.00};
    }

    
    var campofinanciamiento = financiamiento;
    var campoplazo = plazo;
    var campointeres = interes;
    
    var vfinanciamiento = 0
    if (campofinanciamiento.length === 0){
       vfinanciamiento = 0
    } else { vfinanciamiento = campofinanciamiento}
  
    
    var vplazo = 0
    if (campoplazo.length === 0){
       vplazo = 0
    } else { vplazo = campoplazo}
      
    var vinteres = 0
    if (campointeres.length === 0){
       vinteres = 0
    } else { vinteres = campointeres}

    var vcuotas = 0.0
    var vtotal = 0.0
    var porinteres = 0.0

    if (frecPago == "Semanal") {
      porinteres = (parseFloat(vinteres)/4)/100
    }

    if (frecPago == "Quincenal") {
      porinteres = (parseFloat(vinteres)/2)/100
      
    }

    if (frecPago == "Mensual") {
      porinteres = (parseFloat(vinteres)/1)/100
    }

    if (frecPago == "Diario") {
      porinteres = (parseFloat(vinteres)/vplazo)/100
    }

    vtotal = ((vfinanciamiento * porinteres)*vplazo)+parseFloat(vfinanciamiento)
    vcuotas = vtotal / vplazo
  

    return {cuotas:vcuotas.toFixed(2),deuda:vtotal.toFixed(2)};
  }

  export function calculoplazoindefinido(financiamiento,interes,frecPago){

    if( financiamiento === undefined || interes === undefined || frecPago === undefined) {
        return {cuotas:0.00,deuda:0.00};
    }

    
    var campofinanciamiento = financiamiento;
    var campointeres = interes;
    
    var vfinanciamiento = 0
    if (campofinanciamiento.length === 0){
       vfinanciamiento = 0
    } else { vfinanciamiento = campofinanciamiento}
  
          
    var vinteres = 0
    if (campointeres.length === 0){
       vinteres = 0
    } else { vinteres = campointeres}





    var vtotal = ((vfinanciamiento * (vinteres/100)))+parseFloat(vfinanciamiento)
    var vcuotas = (vfinanciamiento * (vinteres/100))
  

    return {cuotas:vcuotas.toFixed(2),deuda:vtotal.toFixed(2)};
  }

  export function calculosolointeres(financiamiento,plazo,interes,frecPago){
    
    var campofinanciamiento = financiamiento===null?financiamiento:financiamiento;
    var campoplazo = plazo===null?plazo:plazo;
    var campointeres = interes===null?interes:interes;
    
    var vfinanciamiento = 0
    if (campofinanciamiento.length === 0){
       vfinanciamiento = 0
    } else { vfinanciamiento = campofinanciamiento}
  
    
    var vplazo = 0
    if (campoplazo.length === 0){
       vplazo = 0
    } else { vplazo = campoplazo}
      
    var vinteres = 0
    if (campointeres.length === 0){
       vinteres = 0
    } else { vinteres = campointeres}

    var vcuotas = 0.0
    var vtotal = 0.0

    var porinteres = 0.0
    if (frecPago == "Semanal") {
      porinteres = (parseFloat(vinteres)/4)/100
    }

    if (frecPago == "Quincenal") {
      porinteres = (parseFloat(vinteres)/2)/100
      
    }

    if (frecPago == "Mensual") {
      porinteres = (parseFloat(vinteres)/1)/100
    }

    if (frecPago == "Diario") {
      porinteres = (parseFloat(vinteres)/vplazo)/100
    }

    
    vtotal = ((vfinanciamiento * porinteres)*vplazo) //+ parseFloat(vfinanciamiento)
    vcuotas = vtotal / vplazo
  
    return {cuotas:vcuotas.toFixed(2),deuda:vtotal.toFixed(2)};
  }

  // Calculate interest rate based on fixed cuota (monthly payment)
  // Calcula la tasa de interés (anualizada) requerida para alcanzar una cuota dada, monto, plazo y frecuencia de pago
  
    
  export function calcularInteresPorCuota(principal, nPagos,cuota, frecuencia) {
    if (!principal || !cuota || !nPagos || !frecuencia) return {interes: 0.00, deuda: 0.00};
  
    const f = String(frecuencia).toLowerCase();
    let k;
    if (f === "mensual") k = 1;
    else if (f === "quincenal") k = 2;
    else if (f === "semanal") k = 4;        
    else if (f === "diario") k = nPagos;    
    else {
      console.error("Frecuencia inválida:", frecuencia);
      return {interes: 0.00, deuda: 0.00};
    }
  
    const ratio = (cuota * nPagos) / principal;            // (Total pagado) / principal
    const rMensual = k * (ratio - 1) / nPagos;             // tasa mensual en decimal

   
    return {interes: Number((rMensual * 100).toFixed(2)), deuda: (cuota * nPagos).toFixed(2)};            // % mensual
  }